// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) {
  .layout-wrapper.layout-static .layout-main-container {
    margin-left: 250px;
  }
}
@media (max-width: 991px) {
  .layout-wrapper .layout-main-container {
    margin-left: 0;
    padding-left: 0rem;
  }
}
.layout-sidebar {
  position: fixed;
  width: 250px;
  height: calc(100vh - 5rem);
  z-index: 999;
  overflow-y: auto;
  -webkit-user-select: none;
  user-select: none;
  top: 5rem;
  left: 0rem;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  border-radius: 0px;
  padding: 1.5rem 0rem 0rem 1.5rem;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAA;EACF;AACF;AAEA;EACE;IACE,cAAA;IACA,kBAAA;EAAF;AACF;AAGA;EACE,eAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gCAAA;EACA,6GAAA;AADF","sourcesContent":["@media (min-width: 992px) {\n  .layout-wrapper.layout-static .layout-main-container {\n    margin-left: 250px;\n  }\n}\n\n@media (max-width: 991px) {\n  .layout-wrapper .layout-main-container {\n    margin-left: 0;\n    padding-left: 0rem;\n  }\n}\n\n.layout-sidebar {\n  position: fixed;\n  width: 250px;\n  height: calc(100vh - 5rem);\n  z-index: 999;\n  overflow-y: auto;\n  -webkit-user-select: none;\n  user-select: none;\n  top: 5rem;\n  left: 0rem;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  border-radius: 0px;\n  padding: 1.5rem 0rem 0rem 1.5rem;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05),\n    0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
